import {openUserDesignDownloadModal, downloadAiChatImage} from '@Components/ai-chat-window/lib/ai-chat-downloads.library';
import {sendPrompt} from '@Components/ai-chat-window/lib/ai-chat-prompt.library';
import type {ButtonAction} from '@Components/ai-chat-window/lib/chat-button-actions.types';
import {ButtonActionType} from '@Components/ai-chat-window/lib/chat-button-actions.types';
import {toDownloadRequest} from '@Components/ai-chat-window/lib/chat-button-actions.library';
import type {AiChatCallbacks} from '@AiChat/callbacks/ai-chat-callbacks.types';
import {UsedAssetKind} from '@AiChat/callbacks/ai-chat-callbacks.types';
import {openCreditPackCheckout} from '@Components/ai-chat-window/lib/ai-chat-credit-checkout.library';
import {openPricingWithPromo} from '@Modals/premium-pricing-modal/premium-pricing-modal.library';
import {NewSubscriptionStartSource} from '@Libraries/ga-events';
import {assertNever} from '@Utils/assert-never.util';

export const dispatchButtonAction = async (action: ButtonAction, promptBoxId: string, callbacks: AiChatCallbacks): Promise<void> => {
  switch (action.type) {
    case ButtonActionType.USE_THIS: {
      callbacks.onUseAsset?.({kind: UsedAssetKind.IMAGE, chatId: action.chatId, messageId: null, imageHashedId: action.hashedId});
      return;
    }
    case ButtonActionType.DOWNLOAD: {
      await downloadAiChatImage(toDownloadRequest(action));
      return;
    }
    case ButtonActionType.DOWNLOAD_DESIGN: {
      openUserDesignDownloadModal(action.posterHashedId, action.pageHashedId);
      return;
    }
    case ButtonActionType.TURN_INTO_VIDEO: {
      // TurnIntoVideoButton owns the generation hook, so a video button never reaches this dispatcher.
      return;
    }
    case ButtonActionType.FILL_PROMPT: {
      sendPrompt(promptBoxId, action.text);
      return;
    }
    case ButtonActionType.UPSELL_PREMIUM: {
      openPricingWithPromo(NewSubscriptionStartSource.AI_CHAT_AGENT_UPSELL, action.promoCode);
      return;
    }
    case ButtonActionType.UPGRADE_PREMIUM: {
      openPricingWithPromo(NewSubscriptionStartSource.AI_CHAT_AGENT_UPSELL);
      return;
    }
    case ButtonActionType.UPSELL_CREDITS: {
      openCreditPackCheckout();
      return;
    }
    default:
      assertNever(action);
  }
};
